const initialState = {
    studentData: {},
    extEventData: null,
    resumeData: {},
    campusDetails: {},
    skillsList: {},
    degreeList: [],
    universityList: {},
    token: '',
    listOfCountry: [],
    listOfState: [],
    listOfCity: [],
    listOfSkill: {},
    functionsList: [],
    designationList: [],
    industryList: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'SET_STUDENT_DATA':
            return {
                ...state,
                studentData: action.payload,
            }
        case 'SET_EXT_EVENT_DATA':
            return {
                ...state,
                extEventData: action.data,
            }
        case 'SET_RESUME_DATA':
            return {
                ...state,
                resumeData: action.payload,
            }
        case 'SET_CAMPUS_DETAILS':
            return {
                ...state,
                campusDetails: action.name,
            }
        case 'SET_SKILLS_LIST':
            return {
                ...state,
                skillsList: action.data,
            }
        case 'SET_DEGREE_LIST':
            return {
                ...state,
                degreeList: action.list,
            }
        case 'SET_UNIVERSITY_LIST':
            return {
                ...state,
                universityList: action.data,
            }
        case 'SET_TOKEN':
            return {
                ...state,
                token: action.token,
            }
        case 'SET_LIST_OF_COUNTRY':
            return {
                ...state,
                listOfCountry: action.list,
            }
        case 'SET_LIST_OF_STATE':
            return {
                ...state,
                listOfState: action.list,
            }
        case 'SET_LIST_OF_CITY':
            return {
                ...state,
                listOfCity: action.list,
            }
        case 'SET_LIST_OF_SKILL':
            return {
                ...state,
                listOfSkill: action.list,
            }
        case 'SET_FUNCTIONS_LIST':
            return {
                ...state,
                functionsList: action.data,
            }
        case 'SET_DESIGNATION_LIST':
            return {
                ...state,
                designationList: action.data,
            }
        case 'SET_INDUSTRY_LIST':
            return {
                ...state,
                industryList: action.data,
            }
        default:
            return state
    }
}
